import * as exBootstrap from '../../../bootstrap';

// ----------------------------------------------------------------------------

function show(element: HTMLElement, config: Record<string, any> = {}): void {
    (element as any).actionModal = false;

    exBootstrap.show('Modal', element, config);
}

function hide(element: HTMLElement, config: Record<string, any> = {}): void {
    (element as any).actionModal = true;

    exBootstrap.hide('Modal', element, config);
}

function toggle(element: HTMLElement, config: Record<string, any> = {}): void {
    exBootstrap.toggle('Modal', element, config);
}

function dispose(element: HTMLElement, config: Record<string, any> = {}): void {
    exBootstrap.dispose('Modal', element, config);
}

// ----------------------------------------------------------------------------

export { show, hide, toggle, dispose };
